import { oc } from "@orpc/contract";
import { openapi } from "@orpc/openapi";
import { z } from "zod";
import { type ContractService, errors, paxRoute } from "../../common";
import { HEARTBEAT_INTERVAL_SECONDS, RecordHeartbeatBody } from "./schemas";

export const service = {
  group: "activity",
  version: "v1alpha1",
  stage: "alpha",
  title: "Pax Activity API",
  description: "Heartbeats from visible browser tabs, from which play sessions are measured.",
} as const satisfies ContractService;

export const recordHeartbeat = oc
  .meta(
    paxRoute({ auth: { kind: "public" }, minimumTier: null, cost: "read" }),
    openapi({
      method: "POST",
      path: "/api/activity/v1alpha1/heartbeats",
      operationId: "activity.heartbeats.create",
      summary: "Record a heartbeat from a visible tab.",
      description: `A visible tab sends one every ${HEARTBEAT_INTERVAL_SECONDS} seconds. The caller's session, when there is one, names the player.`,
      inputStructure: "detailed",
      successStatus: 204,
      successDescription: "The heartbeat was queued for storage.",
    }),
  )
  .errors({
    ...errors.badRequest,
  })
  .input(z.object({ body: RecordHeartbeatBody }));
